import { Component } from 'src/utils';
import homeArrow from './../../../images/home-arrow.png';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import birdFood from './../../../images/bird-food.png';
import template from './search.html';
import tempUnavailable from './../../../images/tempunavailable_L.png';
import tempUnavailable_S from './../../../images/tempunavailable.png';

@Component({
  controllerAs: 'search',
  template
})

export default class Search {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$stateParams',
    '$state',
    'toaster',
    'orderService',
    'spinnerService',
    'orderActions',
    'authService',
    '$window',
    '$location',
    'APP'
  ];

  constructor($scope, $ngRedux, $stateParams, $state, $toaster, $order, $spinner, orderActions, authService,  $window, $location, APP){
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$stateParams = $stateParams;
    this.$window = $window;
    
    this.$state = $state;
    this.APP = APP;
    this.homeArrow = homeArrow;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.birdFood = birdFood;
    this.tempUnavailable= tempUnavailable;
    this.tempUnavailable_S = tempUnavailable_S;
    
    this.$toaster = $toaster;
    this.isCallingAPI = true;
    this.searchTerm = $stateParams.searchTerm ? $stateParams.searchTerm : '';
    this.$stateParams = $stateParams;
    this.$auth = authService; 
    this.isMiscelleneousCategory = 4;
    this.$location = $location;
    this.pwrProduct = {};
    $ngRedux.dispatch(orderActions.setSearchResults([]));
    $spinner.show('appSpinner');
    $order.getSearchResults(this.searchTerm)
    .then(success => {
      this.sendInfoToPowerReview();
    })
      .finally(() => {
        $spinner.hide('appSpinner');
        this.isCallingAPI = false;
      });

    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      profile: state.auth.profile,
      searchResults: state.order.searchResults
    };
  }

  goToDSCDetailPage() {
    // console.log('goToDSCDetailPage');
    this.$state.go('savings-club');
  }
  // returns dsc price if it has else return normal price
  getRegularPrice(item) {
    if(item && item.price ) { 
    return ' $'+(item.price).toFixed(2);
  }
  return '';
  }

  getDscPrice(item) {
    if(item && item.price ) { 
    return ' $'+(item.price * 85 / 100).toFixed(2);
  }
  return '';
  }
  goToGiftPage(store) {
    this.$state.go('gift-card', {'storeName': store});
  }
  isGiftCard(masterProduct) {
    
    var seriesNumber = masterProduct.masterCode.charAt(0);
    var categoryId = masterProduct.category.id;
    return seriesNumber === '9' && categoryId === this.isMiscelleneousCategory;
  }
  getPriceTag(product,isDsc) {
    var priceTag;
    var isDscCategory = product.itemList[0].masterProduct.subCategories[0].category.dscCategory;
    var maxItem = product.itemList[0];
    var regularMaxPrice = (isDsc) ? this.getDscPrice(maxItem) : this.getRegularPrice(maxItem);
    // checking max price
    if(product.itemList.length > 1) {
      var minItem = product.itemList[product.itemList.length-1];

      var regularMinPrice = (isDsc) ? this.getDscPrice(minItem) : this.getRegularPrice(minItem);
      priceTag =    regularMaxPrice;

    }
    else {
      priceTag =  regularMaxPrice;
    }

    return priceTag;

  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  goToNextState(item) {


    let storeName = '';
    if(this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    }
    else {
      if(this.profile.store && this.profile.store.storeName) {
        storeName = this.profile.store.storeURLName;
      } else {
       storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if(this.isGiftCard(item.itemList[0].masterProduct)) {
      this.goToGiftPage(storeName);
      return;
    }
    // let storeName =  false;
    if (storeName) {
      this.$state.go('browse-product.detail', {
        categoryId: item.itemList[0].masterProduct.category.prettyUrl, 
        subCategoryId: item.itemList[0].masterProduct.subCategories[0].prettyUrl, 
        productId: item.itemList[0].masterProduct.prettyUrl,
        itemGroupNumber: item.itemList[0].masterProduct.itemGroupNumber,
        storeName: storeName
       });
    }
    else {
      this.$state.go('browse-product.detail', {
        categoryId: item.itemList[0].masterProduct.category.prettyUrl, 
        subCategoryId: item.itemList[0].masterProduct.subCategories[0].prettyUrl, 
        productId: item.itemList[0].masterProduct.prettyUrl,
        itemGroupNumber: item.itemList[0].masterProduct.itemGroupNumber,
        storeName:  'shop'
       });
    }
  }

  sendInfoToPowerReview(){
    if(this.searchResults!=null && this.searchResults.length>0){
      var pwrItem = {};
    var pwrItemList = [];
    // var pwrIdDiv = document.getElementsByClassName("pwr-review");
    // console.log("pwrdIdDiv : ", pwrIdDiv);
    for(var i=1; i<=this.searchResults.length; i++){
      // pwrIdDiv[i-1].id = "category-snippet-" + i;
      // pwrIdDiv[i-1].setAttribute("id", "category-snippet-" + i);
      pwrItem = {
        api_key: this.APP.AUTH.AUTH_URL.pwr.api_key,
        locale: this.APP.AUTH.AUTH_URL.pwr.locale,
        merchant_group_id: this.APP.AUTH.AUTH_URL.pwr.merchant_group_id,
        merchant_id: this.APP.AUTH.AUTH_URL.pwr.merchant_id,
        page_id: this.searchResults[i-1].itemList[0].masterProduct.masterCode.substring(0, 7),
        components: {
           CategorySnippet: 'category-snippet-'+i
        }
        };
        if(i>1){
          pwrItem.enable_content_collection_modal= false;
        }
        pwrItemList.push(pwrItem);
    }
    console.log("pwrItemList : ", pwrItemList);
    window.pwr = window.pwr || function () {
      (window.pwr.q = window.pwr.q || []).push(arguments); 
     };
    setTimeout(() => {
     window.pwr("render", pwrItemList);
    }, 1500);
    }
  }
  isIpad() {
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }

  isIpad_potrait() {
    return ( this.$window.innerWidth < 769 && this.$window.innerWidth > 1247 );
  }

  isOutOfStock(items){
    var isSubcatOutOfStock = false;
    var j= 0;
    for(var i=0; i<items.itemList.length; i++){
      if(items.itemList[i].isOutOfStock){
        j++;
      }
    }
    if(j==items.itemList.length){
      return true;
    }
  }

  isAvailablebackon(items){
    var availableOn = null;
    for(var i=0; i<items.itemList.length; i++){
      if(items.itemList[i].isOutOfStock){
        availableOn = items.itemList[i].availableBackOn;
        break;
      }
    }
    return availableOn;
  }

}



// WEBPACK FOOTER //
// ./src/app/order/search/search.js